/**
 * The page the reader is on, absolute and lowercased. Origin and path only:
 * the query string and hash can carry a reader's own input, and AC12 bars PII
 * from every link parameter. Browser-only — call it from an effect or handler.
 */
export function currentPageUrl(): string {
  const { origin, pathname } = window.location;
  return `${origin}${pathname}`.toLowerCase();
}
